document.addEventListener(
  "DOMContentLoaded",
  () => {
    // Only the styles that are included as HTML <style> tag.
    const styles = Object.values(document.styleSheets).filter((style) => style.href === null);

    for (const style of styles) {
      const CSSRules = Object.values(style.cssRules);

      for (const rule of CSSRules) {
        // Disable the default BUS styles.
        if (rule.selectorText === ".ytsa_page") style.disabled = true;
      }
    }

    document.querySelectorAll(".nodetype.nodetype-content-bus script[data-query-id]").forEach((script) => {
      const boundary = script.closest(`[data-bus-container="${script.dataset.queryId}"]`);
      const parent = script.closest(`[data-bus-parent="${script.dataset.queryId}"]`);
      if (!boundary || !parent) return;

      // Remove the loader
      parent.querySelectorAll(`[data-bus-loader="${script.dataset.queryId}"]`).forEach((e) => e.remove());

      // We're testing if the BUS form has loaded correctly. We need to use convoluted tests and can't rely on proper
      // events because the BUS javascript loader relies on ancient document.write() calls

      // There should be a comment node containing the original query ID
      const foundComments =
        [...boundary.childNodes].filter(
          (n) => n.nodeType === Node.COMMENT_NODE && n.textContent.search(script.dataset.queryId) >= 0
        ).length > 0;

      // There should be a node with the "ytsa_page" class
      const foundYTSAPage = !!boundary.querySelector(".ytsa_page");

      // The node should contain content with non-zero dimensions
      const foundMeaningfulContent =
        [...boundary.children].filter((n) => (n.clientHeight ?? 0) * (n.clientWidth ?? 0) > 0).length > 0;

      if (!foundComments)
        console.warn(
          "Did not find query ID comment in the BUS form output. This is an indicator that the form did not load properly."
        );
      if (!foundYTSAPage)
        console.warn(
          "Did not find YTSA page in the BUS form output. This is an indicator that the form did not load properly."
        );
      if (!foundMeaningfulContent)
        console.warn(
          "Did not find paintable content in the BUS form output. This is an indicator that the form did not load properly."
        );

      // If none of the three content indicators are hit, we display an error
      // If the data-load-error attribute is set (which should only be set within the NEOS backend), we render a visual
      // error message
      if (!foundComments && !foundYTSAPage && !foundMeaningfulContent) {
        console.error("It seems the BUS form did not load property, as all content indicators have failed.");

        if (script.dataset.loadError) {
          const node = document.createElement("div");
          node.classList.add("bg-tertiary", "p-4");
          node.innerText = script.dataset.loadError;
          script.insertAdjacentElement("afterend", node);
        }
      } else {
        // Remove ytsa_page classes to get rid of font definitions
        boundary.querySelectorAll(".ytsa_page").forEach((e) => {
          e.classList.replace("ytsa_page", "ytsa_page_vgflechtingen");
        });
      }
    });
  },
  { passive: true }
);
